export default __webpack_public_path__ + "static/media/ultratech.7f966638.jpg";